import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { applicationUrls } from 'src/app/shared/application-constants/application-urls.const';
import { ServerResponse } from 'src/app/shared/models/dto/server-response.dto';
import {
  ErrorHandler,
  HttpErrorHandler,
} from 'src/app/shared/services/http-error-handler.service';
import { RplService } from '../../stp-operations/services/rpl.service';
import { RplIndividualAssessmentSearch } from '../models/rpl-individual-assessment-search';
import {
  CandidateSearchPayload
} from "../components/rpl-individual-batch-schedule-layer1/rpl-individual-batch-schedule.component";
@Injectable({
  providedIn: 'root',
})
export class RplIndivStorageService {
  private handleError: ErrorHandler;
  constructor(
    private httpClient: HttpClient,
    private httpErrorHandler: HttpErrorHandler,
    private rplService: RplService
  ) {
    this.handleError =
      this.httpErrorHandler.createErrorHandler('Freelancer Service');
  }

  //#region payment for rpl batch assessment
  save(applicationDetails: any): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.RPLIndividual.save}`,
        applicationDetails
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  //#endregion

  update(applicationDetails: any): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.RPLIndividual.update}`,
        applicationDetails
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  customizeCandidates(applicationDetails: any): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.RPLIndividual.customizeCandidates}`,
        applicationDetails
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  submitRplIndividualAssessmentApplication(applicationId: number) {
    const url =
      applicationUrls.RPLIndividual.submitIndividualAssessment +
      '?applicationId=' +
      applicationId;
    return this.httpClient.get<ServerResponse>(url);
  }

  getAllCandidateByAssessmentApplyId(assessmentApplyId: number) {
    const url =
      applicationUrls.RPLIndividual.getAllCandidateByAssessmentApplyId +
      '?assessmentApplyId=' +
      assessmentApplyId;
    return this.httpClient.get<ServerResponse>(url);
  }

  removeProfileApplicant(assessmentApplyId: number, profileDetailsId: number) {
    let url =
      applicationUrls.RPLIndividual.setCandidateAssessmentApplicationIdToNull;
    url =
      url +
      '?assessmentApplyId=' +
      assessmentApplyId +
      '&applicantDetailsId=' +
      profileDetailsId;

    return this.httpClient.get<ServerResponse>(url);
  }

  deleteRplIndividualAssessmentApplication(assessmentApplyId: number) {
    const url =
      applicationUrls.RPLIndividual.deleteAssessmentApplicationById +
      assessmentApplyId;
    return this.httpClient.delete<ServerResponse>(url);
  }

  //#region payment for rpl batch assessment
  getAllAssessmentApplications(
    data: any,
    size: number,
    page: number,
    sortingKey: any,
    sortingValue: any
  ): Observable<ServerResponse> {
    const pageableRequestBodyDTO = {
      page: page - 1,
      size: size,
      sortingKey: sortingKey ? sortingKey : null,
      sortingValue: sortingValue ? sortingValue : null,
      occupationId: data?.occupationId ? data?.occupationId : null,
      levelId: data?.levelId ? data?.levelId : null,
      assessmentTypeId: data?.assessmentTypeId ? data?.assessmentTypeId : null,
    };
    console.log(data);
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.RPLIndividual.getPageableApplicationList}`,
        pageableRequestBodyDTO
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  //#endregion
  //#region download Assessment Application Report Stp info
  onDownloadAssessmentApplicationReportStp(
    data: any,
    pageSize: number,
    currentPage: number,
    sortingKey: any,
    sortingValue: any
  ): Observable<ServerResponse> {
    let object = {
      occupationId: data.occupationId,
      levelId: data.levelId,
      statusTypeId: data.statusTypeId,
      assessmentTypeId: data.assessmentTypeId,
      pageSize: pageSize,
      pageNumber: currentPage,
      sortingKey: sortingKey,
      sortingValue: sortingValue,
      disabled: true,
    };
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.assessment.downloadAssessmentApplicationReportStp}`,
      object
    );
  }
  //#endregion

  //#region read rpl individual Assessment list admin
  readRplIndividualAssessmentListInfoAdmin(
    rplIndividualAssessmentSearch: RplIndividualAssessmentSearch
  ): Observable<ServerResponse> {
    rplIndividualAssessmentSearch = {
      ...rplIndividualAssessmentSearch,
      disabled: false,
    };
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.RPLIndividual.readRplIndividualAssessmentListInfo}`,
      rplIndividualAssessmentSearch
    );
  }

  onDownloadRplIndividualAssessmentReport(
    rplIndividualAssessmentSearch: any
  ): Observable<ServerResponse> {
    const payload = {
      ...rplIndividualAssessmentSearch,
      disabled: true,
    };
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.RPLIndividual.readRplIndividualAssessmentListInfo}`,
      payload
    );
  }
  //#endregion

  //#region candidate list
  // readRplIndiCandidateList(
  //   name: string,
  //   registrationNo: string,
  //   nidBirthId: string,
  //   email: string,
  //   contactNo: string,
  //   page?: number | 0,
  //   size?: number | 10,
  //   sortingKey?: string | null,
  //   sortingValue?: string | null
  // ): Observable<ServerResponse> {
  //   let pageableRequestDTO = {
  //     name: name,
  //     registrationNo: registrationNo,
  //     nidBirthId: nidBirthId,
  //     email: email,
  //     contactNo: contactNo,
  //     page: page,
  //     size: size,
  //     sortingKey: sortingKey,
  //     sortingValue: sortingValue,
  //   };
  //   return this.httpClient.post<ServerResponse>(
  //     `${applicationUrls.rpl.getNullableAssessApplyIdCandidateList}`,
  //     pageableRequestDTO
  //   );
  // }

  readRplIndiCandidateList(tamMainId: number): Observable<ServerResponse> {
    const payload = { tamMainId: tamMainId };
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.RPLIndividual.readRplIndiCandidateList}`,
      payload
    );
  }

  readRplIndiCandidateList_(payload: CandidateSearchPayload): Observable<ServerResponse> {
    return this.httpClient.post<ServerResponse>(applicationUrls.RPLIndividual.readRplIndiCandidateList, payload
    );
  }

  //#endregion

  getApprovedAssessmentCenter(tamMainId: number, occupationId: number, levelId: number, tamTypeId: number): Observable<ServerResponse> {
    const payload = {
      tamMainId: tamMainId,
      occupationId: occupationId,
      levelId: levelId,
      tamTypeId: tamTypeId,
      // a center whose STP/SAC registration has expired can't be chosen
      excludeExpiredStp: true,
    }
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.regBatchAssessment.getApprovedAssessmentCenter}`,
      payload
    );
  }

  //#region assessors by occupation and level
  getAssessorsByOccupationAndLevel(occupationId: number, levelId: number) {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.rpl.readAssessorsByOccupationAndLevel}?occupationId=${occupationId}&levelId=${levelId}`
    );
  }
  //#endregion

  //#region get review application info by id
  readApplicationInfoById(applicationId: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.RPLIndividual.readRplIndiApplicationInfoById}` +
          applicationId
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return null;
          }
          return serverResponse;
        })
      );
  }
  //#endregion

  submitRplIndividualLevelTwoThreeFourScheduleRecommendationProcess(
    id?: any,
    recommendationTypeId?: number,
    remarks?: string,
    levelOnePermission?: string,
    levelTwoPermission?: string,
    levelThreePermission?: string,
    levelFourPermission?: string,
    // true after the admin chose "Continue at own risk" for an expired assessment center
    continueWithExpiredStp?: boolean
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.submitProcess}`,
      {
        rplIndiAssessApplyId: id,
        recommendationTypeId: recommendationTypeId,
        remarks: remarks,
        levelOnePermission: levelOnePermission,
        levelTwoPermission: levelTwoPermission,
        levelThreePermission: levelThreePermission,
        levelFourPermission: levelFourPermission,
        continueWithExpiredStp: continueWithExpiredStp,
      }
    );
  }

  rollBackRplIndividualLevelTwoThreeFourScheduleRecommendationProcess(
    id?: any,
    remarks?: string
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.processRollBack}`,
      { rplIndiAssessApplyId: id, remarks: remarks }
    );
  }

  getApprovedCsOccupationsandLevel(
    payload: { occupationLevelIds: { occupationId: number; levelId: number }[]; tamType: number }
  ): Observable<ServerResponse> {

    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.tamMain.readApprovedCSOccupationAndLevel}`,
      payload
    );
  }

  //#region roll back
  getApprovedCsOccupations(
    occupationIds: any[],
    tamType: number
  ): Observable<ServerResponse> {
    const payload = {
      occupationIds: occupationIds,
      tamType: tamType,
    };
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.tamMain.readApprovedCSOccupation}`,
      payload
    );
  }
  //#endregion

  //#region read RPL Assessment
  readRplIndivAssignedAssessmentInfo(
    rplIndividualAssessmentSearch: RplIndividualAssessmentSearch
  ): Observable<ServerResponse> {
    rplIndividualAssessmentSearch.disabled = false;
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.RPLIndividual.getRplIndivAssignedAssessmentInfo}`,
      rplIndividualAssessmentSearch
    );
  }

  getAllRplIndividualRepresentationAssessmentApplications(
    rplIndividualAssessmentSearch: RplIndividualAssessmentSearch
  ): Observable<ServerResponse> {
    rplIndividualAssessmentSearch.disabled = false;
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.RPLIndividual.getAllRplIndividualRepresentationAssessmentApplications}`,
      rplIndividualAssessmentSearch
    );
  }

  getAssessorPoolInfoByAssessorId(
    assessorId: number
  ): Observable<ServerResponse> {
    const params = new HttpParams().append('assessorId', `${assessorId}`);
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.assessor.getAssessorPoolInfoByAssessorId}`,
      { params }
    );
  }

  //#region get Upload Results info by id
  readUploadResultsInfoById(applicationId: number): Observable<any> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.RPLIndividual.readUploadResultsInfoById}` +
          applicationId
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return null;
          }
          return serverResponse;
        })
      );
  }

  //#region upload and save results
  saveResults(results: FormData): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.RPLIndividual.saveResults}`,
        results
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  //#endregion

  //#region update uploaded results
  updateResults(results: FormData): Observable<ServerResponse> {
    return this.httpClient
      .post<ServerResponse>(
        `${applicationUrls.RPLIndividual.updateUploadedResults}`,
        results
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }
  //#endregion

  //#region Submit assessment result
  onSubmitAssessmentResult(applicationId: number): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.submitAssessmentResult}`,
      { applicationId: applicationId }
    );
  }
  //#endregion

  //#region assessors by occupation and level
  getAssessorsByOccupationAndLevelForResults(
    occupationId: number,
    levelId: number,
    applicationId: number
  ) {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.RPLIndividual.readAssessorsByOccupationAndLevelForRplResults}?occupationId=${occupationId}&levelId=${levelId}&applicationId=${applicationId}`
    );
  }
  //#endregion

  //#region Approve Result
  // continueWithExpiredStp: true after the admin chose "Continue at own risk" for an expired assessment center
  onApproveResult(applicationId: number, continueWithExpiredStp = false): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.approveResults}`,
      { applicationId: applicationId, continueWithExpiredStp: continueWithExpiredStp }
    );
  }
  //#endregion

  //#region need clarification
  needClarification(
    applicationId: number,
    clarificationOrCorrectionRemarks: string
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.needClarification}`,
      {
        applicationId: applicationId,
        clarificationOrCorrectionRemarks: clarificationOrCorrectionRemarks,
      }
    );
  }
  //#endregion

  //#region issue certificates
  onIssueCertificates(applicationId: number, continueWithExpiredStp = false): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.issueCertificates}`,
      { applicationId: applicationId, continueWithExpiredStp: continueWithExpiredStp }
    );
  }
  //#endregion

  //#region assessor need correction
  assessorNeedCorrection(
    applicationId: number,
    assessorId: number,
    assessorTwo: number | null = null,
    assessorRemarks: string,
    isNeedToRollBackResultForBothAssessor: boolean
  ): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.assessorNeedCorrection}`,
      {
        assessApplyId: applicationId,
        assessorId: assessorId,
        assessorTwo: assessorTwo,
        assessorRemarks: assessorRemarks,
        isNeedToRollBackResultForBothAssessor:
          isNeedToRollBackResultForBothAssessor,
      }
    );
  }
  //#endregion

  //#region download certificate
  onCollectdataToDownloadCertificate(candidateId: number): Observable<any[]> {
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.RPLIndividual.collectDataToDownloadCertificate}` +
          candidateId
      )
      .pipe(
        map((serverResponse: ServerResponse) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        })
      );
  }
  //#endregion

  //#region rpl candidate info for QR Code
  getCertificateDataForCandidate(id: any): any {
    const userId = encodeURIComponent(id ?? '');
    return this.httpClient
      .get<ServerResponse>(
        `${applicationUrls.RPLIndividual.getCertificateDataForCandidate}` +
          '?id=' +
          userId
      )
      .pipe(
        map((serverResponse: any) => {
          if (!serverResponse.data) {
            return [];
          }
          return serverResponse.data;
        }),
        tap((result: any) => {
          return result.data;
        })
      );
  }
  //#endregion

  //#region download certificate
  readCertificateInfoFromTci(candidate: any): any {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.tci.readCertificateInfoFromTci}`,
      candidate
    );
  }
  //#endregion


  //#region apply for re assessment
  onApplyForReAssessment(profileApplicantDetailsId: number): Observable<ServerResponse> {
    return this.httpClient.put<ServerResponse>(
      `${applicationUrls.RPLIndividual.onApplyForReAssessment}`,
      { profileApplicantDetailsId: profileApplicantDetailsId }
    );
  }
  //#endregion

  getBasicInformation(
    id: any
  ): Observable<ServerResponse> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.RPLIndividual.getBasicInformation}` +
      id
    );
  }


  updateBasicInformation(basicInfo: any) {
    return this.httpClient.post<ServerResponse>(
      `${applicationUrls.RPLIndividual.updateBasicInformation}`,
      basicInfo
    );
  }

  getRPLApplicationHistory(assessmentApplyId: number): Observable<ServerResponse> {
    const url = `${applicationUrls.RPLIndividual.profileHistory}/${assessmentApplyId}`;
    return this.httpClient.get<ServerResponse>(url);
  }
  // updateBasicInformation(
  //   rplIndividualAssessmentSearch: RplIndividualAssessmentSearch
  // ): Observable<ServerResponse> {
  //   rplIndividualAssessmentSearch.disabled = false;
  //   return this.httpClient.post<ServerResponse>(
  //     `${applicationUrls.RPLIndividual.readRplIndividualAssessmentListInfo}`,
  //     rplIndividualAssessmentSearch
  //   );
  // }

  onDownloadRPLIndvAssessmentReportUsingJasper(
    assessApplyId: number,
    // assessorRefIdOne: number,
    exportTypeId: string
  ): Observable<ServerResponse> {
    const params = new HttpParams()
      .append('assessApplyId', `${assessApplyId}`)
      // .append('assessorRefIdOne', `${assessorRefIdOne}`)
      .append('exportTypeId', `${exportTypeId}`);
    return this.httpClient
      .get<ServerResponse>(`${applicationUrls.jasper.onDownloadRplIndvMainReport}`, {
        params,
      })
      .pipe(
        map((serverResponse: ServerResponse) => {
          return serverResponse;
        })
      );
  }

  //#endregion

  readRplIndivResultStatusInfoById(applicationId: number): Observable<any> {
    return this.httpClient.get<ServerResponse>(
      `${applicationUrls.RPLIndividual.rplIndResultStatus}?assessApplyId=${applicationId}`
    );
  }

}
